import {VueConstructor} from 'vue'
import VueRouter, {RouteConfig, RouterMode} from 'vue-router'
import _default from './routes/default'
// tree shacking for production
const test = process.env.NODE_ENV !== 'production' ? require('./routes/test').default : undefined

const router = (Vue: VueConstructor, mode: RouterMode = 'history') => {
  /**
   * router.push/replace의 exception을 무시하는 이유
   * @link https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378
   */
  Vue.use(VueRouter)

  const routes: RouteConfig[] = [
    // production routes
    {
      path: '/',
      component: () => (import(
        /* webpackMode: "eager" */
        'layouts/default/Index.vue')),
      children: _default,
    },

  ]

  // tree shacking for production
  if(test) {
    // for testing
    routes.push({
      path: '/test',
      component: () => (import('layouts/Test.vue')),
      children: test,
    })
  }
  routes.push({
    path: '*',
    component: () => (import('pages/NotFound.vue')),
  })
  return new VueRouter({
    mode,
    routes,
  })
}

export default router
